import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import CtaButton from '@components/CtaButton/CtaButton'
import RotatingContent from '@components/RotatingContent/RotatingContent'

import heroImage1 from '@static/images/hero-banner/slide1.jpg'
import heroImage2 from '@static/images/hero-banner/slide2.jpg'
import heroImage3 from '@static/images/hero-banner/slide3.jpg'
import aDigital from '@static/vectors/adigital-logo.svg'
import './Herobanner.css'
import LoginButton from '@components/LoginButton/LoginButton'

export default function Herobanner() {
  return (
    <section id="hero-banner">
      <div className="element element-stats" />
      <div className="element element-circle" />
      <div className="container">
        <div className="info-wrapper">
          <section className="powered-by">
            <p>
              <span>
                <FormattedMessage id="home.hero-banner.powered-by" />
              </span>
              <img src={aDigital} alt="adigital logo" />
            </p>
          </section>
          <h1>
            <MarkdownMessage id="home.hero-banner.title" />
          </h1>
          <p>
            <FormattedMessage id="home.hero-banner.text" />
          </p>
          <div className="buttons">
            <CtaButton />
            <LoginButton />
          </div>
        </div>

        <RotatingContent className="video-wrapper">
          <video autoPlay muted loop playsInline poster={heroImage1}>
            <source src="d" type="video/mp4" />
            <img src={heroImage1} alt="hero banner animation fallback" />
          </video>
          <video autoPlay muted loop playsInline poster={heroImage2}>
            <source src="d" type="video/mp4" />
            <img src={heroImage2} alt="hero banner animation fallback" />
          </video>
          <video autoPlay muted loop playsInline poster={heroImage3}>
            <source src="d" type="video/mp4" />
            <img src={heroImage3} alt="hero banner animation fallback" />
          </video>
        </RotatingContent>
      </div>
    </section>
  )
}
